const WisdomSpace = {
  //项目金主
  path: 'wisdom-space',
  component: () => import("@/views/home/wisdom-space/wisdom-space"),
  meta: {
    // tabBar: 'home'
    tabBar: false
  },
  children:[
    {
      path: 'enter-apply',
      component: () => import("@/views/home/wisdom-space/enter-apply"),
      meta: {
        tabBar: false
      }
    },
    {
      path: 'apply-success',
      component: () => import("@/views/home/wisdom-space/apply-success"),
      meta: {
        tabBar: false
      }
    },
  ]
};

export default WisdomSpace;
